'use client';

import * as React from 'react';
import { useSessionStorageValue } from '@react-hookz/web';
import { useTranslations } from 'next-intl';
import { toast } from 'ui';

export function PreviewModeToast(): JSX.Element {
  const t = useTranslations('Blog.Realtime');
  const { value: hasShownToast, set: setHasShownToast } =
    useSessionStorageValue('preview-mode-toast', {
      defaultValue: false,
    });
  React.useEffect(() => {
    if (hasShownToast) {
      return;
    }
    toast.info(t('ToastTitle'), {
      description: t('ToastDescription'),
      duration: 10_000,
    });
    setHasShownToast(true);
  }, [t, hasShownToast, setHasShownToast]);

  return <></>;
}
